// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3fuLj","content":"RecentSearches_content__3qoru"};